export default class EditProjectViewmodel {
    public id: number = 0;
    public name: string = '';
    public instructingParty: number = 0;
    public managingConsultant: string = '';
}